module.exports = __webpack_public_path__ + "static/img/bg-right.5fb8b1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg-right.png
// module id = J6PC
// module chunks = 1